'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  color: ', ';\n  font-family: ', ';\n  font-size: ', ';\n  font-weight: ', ';\n  border-bottom: ', ';\n  ', '\n  ', ';\n  justify-content: ', ';\n  line-height: ', ';\n  text-align: ', ';\n  text-indent: ', ';\n  text-transform: ', ';\n  text-overflow: ', ';\n  user-select: ', ';\n  white-space: ', ';\n  width: ', ';\n  word-break: ', ';\n'], ['\n  color: ', ';\n  font-family: ', ';\n  font-size: ', ';\n  font-weight: ', ';\n  border-bottom: ', ';\n  ', '\n  ', ';\n  justify-content: ', ';\n  line-height: ', ';\n  text-align: ', ';\n  text-indent: ', ';\n  text-transform: ', ';\n  text-overflow: ', ';\n  user-select: ', ';\n  white-space: ', ';\n  width: ', ';\n  word-break: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _themeProps = require('@hixme-ui/theme-props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextBase = _styledComponents2.default.span(_templateObject, function (props) {
  return props.color || (0, _themeProps.getTextColor)(props, 'inherit');
}, function (props) {
  return props.fontFamily || (0, _themeProps.getFontFamily)(props);
}, function (props) {
  return props.fontSize || (0, _themeProps.getFontSize)(props, 'inherit');
}, function (props) {
  return props.fontWeight || (0, _themeProps.getFontWeight)(props);
}, function (props) {
  if (props.dashed) return '1px dashed';
  return 'none';
}, function (_ref) {
  var a = _ref.a,
      cursor = _ref.cursor;
  return (a || cursor) && 'cursor: ' + (cursor || 'pointer') + ';';
}, function (props) {
  return props.display && 'display: ' + props.display;
}, function (props) {
  if (props.right) return 'flex-end';
  if (props.left) return 'flex-start';
  if (props.center) return 'center';
  return 'flex-start';
}, function (props) {
  return props.lineHeight || 'inherit';
}, function (props) {
  if (props.left) return 'left';
  if (props.center) return 'center';
  if (props.right) return 'right';
  return 'inherit';
}, function (props) {
  return props.textIndent || 'inherit';
}, function (props) {
  if (props.uppercase) return 'uppercase';
  if (props.lowercase) return 'lowercase';
  if (props.capitalize) return 'capitalize';
  return 'none';
}, function (props) {
  return props.textOverflow || 'inherit';
}, function (props) {
  return props.userSelect || 'inherit';
}, function (props) {
  return props.whiteSpace || 'inherit';
}, function (props) {
  if (props.right || props.left || props.center) return '100%';
  return 'auto';
}, function (props) {
  if (props.wordBreak) return props.wordBreak;
  return 'inherit';
});

TextBase.displayName = 'hui:TextBase';
TextBase.huiName = 'TextBase';

exports.default = TextBase;
//# sourceMappingURL=TextBase.js.map


//////////////////
// WEBPACK FOOTER
// ../text/lib/TextBase.js
// module id = 128
// module chunks = 0